export const EQ_TYPES_MAP: { [key: string]: { id: string; name: string; key: number } } = {
  V: { id: 'V', name: 'Dry Van', key: 1 },
  R: { id: 'R', name: 'Reefer', key: 2 },
  F: { id: 'F', name: 'Flatbed', key: 3 },
  T: { id: 'T', name: 'Bulk/Tanker', key: 14 },
  CO: { id: 'CO', name: 'Conestoga', key: 13 },
  C: { id: 'C', name: 'Container', key: 7 },
  DD: { id: 'DD', name: 'Double Drop', key: 17 },
  LA: { id: 'LA', name: 'Drop Deck Landoll', key: 24 },
  HS: { id: 'HS', name: 'Hot Shot', key: 9 },
  PO: { id: 'PO', name: 'Power Only', key: 8 },
  RG: { id: 'RG', name: 'Removeable Gooseneck', key: 16 },
  SC: { id: 'SC', name: 'Sprinter/Cargo Van', key: 19 },
  SD: { id: 'SD', name: 'Step Deck', key: 10 },
  SB: { id: 'SB', name: 'Straight Box Truck', key: 20 },
  ST: { id: 'ST', name: 'Stretch Trailer', key: 26 },
  VV: { id: 'VV', name: 'Vented Van', key: 15 }
}

export const NEW_EQ_TYPES_MAP: { [key: string]: { id: string; name: string; key: number } } = {
  V: { id: 'V', name: 'Van', key: 1 },
  R: { id: 'R', name: 'Reefer', key: 2 },
  F: { id: 'F', name: 'Flatbed', key: 3 },
  T: { id: 'T', name: 'Bulk/Tanker', key: 14 },
  CO: { id: 'CO', name: 'Conestoga', key: 13 },
  C: { id: 'C', name: 'Container', key: 7 },
  DD: { id: 'DD', name: 'Double Drop', key: 17 },
  LA: { id: 'LA', name: 'Drop Deck Landoll', key: 24 },
  RG: { id: 'RG', name: 'Removeable Gooseneck', key: 16 },
  SC: { id: 'SC', name: 'Sprinter/Cargo Van', key: 19 },
  SD: { id: 'SD', name: 'Step Deck', key: 10 },
  SB: { id: 'SB', name: 'Straight Box Truck', key: 20 },
  ST: { id: 'ST', name: 'Stretch Trailer', key: 26 },
  VV: { id: 'VV', name: 'Vented Van', key: 15 },
  MX: { id: 'MX', name: 'Maxi', key: 28 },
  AU: { id: 'AU', name: 'Auto Trailer', key: 29 },
  MV: { id: 'MV', name: 'Moving Van', key: 30 },
  H: { id: 'H', name: 'Hooper', key: 31 },
  AT: { id: 'AT', name: 'A-Train', key: 32 },
  BT: { id: 'BT', name: 'B-Train', key: 33 },
  CT: { id: 'CT', name: 'C-Train', key: 34 },
  P: { id: 'P', name: 'Pneumatic', key: 35 }
};

export const ALL_EQ_TYPES_MAP: { [key: string]: { id: string; name: string; key: number } } = {
  ...EQ_TYPES_MAP,
  ...NEW_EQ_TYPES_MAP
}

export const ALL_EQ_TYPES_MAP_BY_ID: { [key: number]: { code: string; description: string } } = {
  1: { code: 'V', description: 'Van' },
  2: { code: 'R', description: 'Refrigerated' },
  3: { code: 'F', description: 'Flatbed' },
  4: { code: 'VR', description: 'Van or Reefer' },
  5: { code: 'VF', description: 'Van or Flatbed' },
  6: { code: 'VRF', description: 'Van / Reefer / Flatbed' },
  7: { code: 'C', description: 'Container' },
  8: { code: 'PO', description: 'Power Only' },
  9: { code: 'HS', description: 'Hot Shot' },
  10: { code: 'SD', description: 'Step Deck' },
  11: { code: 'RVV', description: 'Reefer or Vented Van' },
  12: { code: 'FS', description: 'Flatbed or Stepdeck' },
  13: { code: 'FC', description: 'Flatbed or Conestoga' },
  14: { code: 'T', description: 'Bulk/Tanker' },
  15: { code: 'VV', description: 'Vented Van' },
  16: { code: 'RG', description: 'Removeable Gooseneck' },
  17: { code: 'DD', description: 'Double Drop' },
  18: { code: 'RD', description: 'Rem Gooseneck or Double Drop' },
  19: { code: 'SC', description: 'Sprinter/Cargo Van' },
  20: { code: 'SB', description: 'Straight/Box Truck' },
  21: { code: 'FH', description: 'Flatbed Hotshot' },
  22: { code: 'FN', description: 'Flatbed Conestoga' },
  23: { code: 'SN', description: 'Stepdeck Conestoga' },
  24: { code: 'LA', description: 'Landoll' },
  25: { code: 'LB', description: 'Lowboy' },
  26: { code: 'ST', description: 'Stretch Trailer' },
  27: { code: 'FSH', description: 'Flatbed / Step Deck / Flatbed Hotshot' },
  28: { code: 'MX', description: 'Maxi' },
  29: { code: 'AU', description: 'Auto Trailer' },
  30: { code: 'MV', description: 'Moving Van' },
  31: { code: 'H', description: 'Hooper' },
  32: { code: 'AT', description: 'A-Train' },
  33: { code: 'BT', description: 'B-Train' },
  34: { code: 'CT', description: 'C-Train' },
  35: { code: 'P', description: 'Pneumatic' },
  36: { code: 'CR', description: 'Container Refrigerated' },
  37: { code: 'CF', description: 'Container Flatbed' }
}

export const EQUIPMENT_TYPES_ID_MAP: { [key: string]: Array<number> } = {
  V: [1, 4, 5, 6],
  R: [2, 4, 11, 6, 36],
  F: [3, 5, 6, 9, 12, 13, 21, 22, 27, 37],
  T: [14],
  CO: [13, 22, 23],
  C: [7, 36, 37],
  HS: [9, 21, 27],
  PO: [8],
  SD: [10, 12, 23, 27],
  VV: [15, 11],
  RG: [16, 17, 18, 25],
  DD: [17, 18, 25],
  SC: [19],
  SB: [20],
  LA: [24],
  ST: [26],
  MX: [28],
  AU: [29],
  MV: [30],
  H: [31],
  AT: [32],
  BT: [33],
  CT: [34],
  P: [35]
}
export const EQUIPMENT_TYPES_MAP: { [key: string]: Array<string> } = {
  V: ['V', 'VR', 'VF', 'VRF'],
  R: ['R', 'RVV', 'VRF', 'VR', 'CR'],
  F: ['F', 'VF', 'VRF', 'HS', 'FS', 'FC', 'FH', 'FN', 'FSH', 'CF'],
  T: ['T'],
  CO: ['CO', 'FC', 'FN', 'SN'],
  C: ['C', 'CR', 'CF'],
  HS: ['HS', 'FH', 'FSH'],
  PO: ['PO'],
  SD: ['SD', 'FS', 'SN', 'FSH'],
  VV: ['VV', 'RVV'],
  RG: ['RG', 'DD', 'RD', 'LB'],
  DD: ['DD', 'RD', 'LB'],
  SC: ['SC'],
  SB: ['SB'],
  LA: ['LA'],
  ST: ['ST'],
  MX: ['MX'],
  AU: ['AU'],
  MV: ['MV'],
  H: ['H'],
  AT: ['AT'],
  BT: ['BT'],
  CT: ['CT'],
  P: ['P']
};

export const EQ_TYPE_ID_MAP: { [key: number]: string } = {
  1: 'Dry Van',
  2: 'Reefer',
  3: 'Flatbed',
  14: 'Bulk/Tanker',
  13: 'Conestoga',
  7: 'Container',
  17: 'Double Drop',
  24: 'Drop Deck Landoll',
  9: 'Hot Shot',
  8: 'Power Only',
  16: 'Removeable Gooseneck',
  19: 'Sprinter/Cargo Van',
  10: 'Step Deck',
  20: 'Straight Box Truck',
  26: 'Stretch Trailer',
  15: 'Vented Van'
}
